import classNames from 'classnames';
import { t } from 'ttag';

import { Title } from '@ui/Title';
import { Link } from '@ui/Link';

import s from './CatalogSiblings.sss';

export interface Sibling {
  id: string,
  name: string,
  url: string,
}

interface CatalogSiblingsProps {
  className?: string,
  citySlug?: string,
  siblings: Sibling[],
}

export const CatalogSiblings: React.FC<CatalogSiblingsProps> = ({
  className,
  citySlug,
  siblings,
}) => {
  if (!siblings.length) {
    return null;
  }

  return (
    <div className={classNames(s.root, className)}>
      <Title type="h5" className={s.title}>
        {t`Інші категорії`}
      </Title>

      <ul className={s.list}>
        {siblings.map(({ id, url, name }) => (
          <li
            key={id}
            className={s.item}
          >
            <Link
              className={s.link}
              theme="black"
              to={url + (citySlug ? `/gorod-${citySlug}` : '')}
            >
              {name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
